import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    /* background-color: ${(props) => props.theme.colors.gray.gray_50}; */
    border-radius: 4px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
`;

export const ContentPayment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    box-shadow: 1px 2px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 10px;
`;

export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    `;

export const Infor = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_600};
    font-size: 14px;
    padding: 4px 8px;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.gray.gray_600};
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    padding: 4px 8px;
    border-radius: 30px;
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_200};
        color: ${(props) => props.theme.colors.white};

    }
`;

export const ButtonRemove = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.red.red_50};
    
    padding: 4px 8px;
    border-radius: 30px;
    
    &:hover{
        color: ${(props) => props.theme.colors.red.red_800};
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    /* input{
        &::placeholder{
            color: ${(props) => props.theme.colors.gray.gray_200};
        }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
        background-color: transparent;

    } */
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_200};
    padding: 10px;
    width: 100%;

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const Select = styled.select`
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
    border-radius: 4px;
    padding: 10px;
    width: 100%;

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;